module.exports = __webpack_public_path__ + "img/ai.9fe4d6b7.svg";